var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',[(_vm.$store.state.qlikAuthenticated)?_c('v-card-text',[_c('iframe',{staticStyle:{"position":"absolute","top":"0","left":"0","bottom":"0","right":"0","width":"100%","height":"90vh","border":"none","margin":"0","padding":"0","overflow":"hidden"},attrs:{"src":_vm.$store.state.deepLink}})]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }